import styled from 'styled-components';
import bg_09 from '../../assets/images/bg_09.png';

export const Wrapper = styled.div`
  background: #f4f4f4;  
`;

export const Container = styled.div`
  .banner{
    width:100%;display:block;position:relative;z-index:1;
    width:100%;height:4rem;background:url(${bg_09}) no-repeat;background-size:100%;padding-top:.7rem;
    p{
      height: .38rem;font-size: .4rem;font-weight: 300;color: #FFFFFF;line-height: .38rem;text-align: center;
    }
    span{
      height: .54rem;font-size: .72rem;font-weight: 600;color: #FFFFFF;line-height: .54rem;display: block;text-align: center;margin-top:.25rem;
    }
  }
  .main{
    padding:0 .3rem;
    .center{
      height: 10.15rem;background: #FFFFFF;border-radius: .1rem;margin-top:-1rem;position:relative;z-index:2;
      .content{
        display:flex;padding:0 .3rem;
      }
      .title{
        font-size: .22rem;font-weight: 300;color: #999999;line-height: .3rem;margin-top:.7rem;padding: 0 .2rem;
      }
      .times{
        height: 7.72rem;margin-top:.4rem;position: relative;display: flex;flex-direction: column;overflow: hidden;
        div{
          flex: 1;
          p{
            height: .27rem;font-size: .28rem;font-weight: 300;color: #FC8B8F;line-height: .27rem;text-align:right;
          }
          span{
            height: .22rem;font-size: .28rem;font-weight: 300;color: #FC8B8F;line-height: .22rem;display:block;margin-top:.1rem;
          }
        }
        div:nth-child(2){
          p{
            margin-top: -.1rem;
          }
        }
        div:nth-child(3){
          p{
            margin-top: -.2rem;
          }
        }
        div:last-child{
          position: absolute;bottom: .02rem;
        }
      }
      .under{
        width: .5rem;height: 7.5rem;position: relative;margin:.6rem .2rem 0 .1rem;
        .def{
          width: 1px;height: 7.3rem;background: #DDDDDD;margin: 0 auto;position: relative;z-index: 1;
        }
        .os{
          width: .22rem;height: 7.3rem;margin: 0 auto;top: -7.3rem;
          display: flex;flex-direction: column;overflow: hidden;position: relative;z-index: 2;
          p{
            flex: 1;position: relative;
            span{
              width: .21rem;height: .21rem;border-radius: 50%;background: #DDDDDD;display: block;position: relative;
            }
            span.active{
              background: #FC8B8F;
            }
          }
          p:last-child{
            position: absolute;bottom: 0;
          }
        }
        .on{
          width: .5rem;height: 7.5rem;margin: 0 auto;top: -14.6rem;
          display: flex;flex-direction: column;overflow: hidden;position: relative;z-index: 3;
          span{
            width: .2rem;height: .2rem;border-radius: 50%;background: #FC8B8F;display: block;position: relative;margin: 0 auto;
          }
          p{
            width: .06rem;background: #FC8B8F;margin:0 auto;transition: all 2s;
          }
          b{
            width: .5rem;height: .5rem;background: #FFFFFF;border: .06rem solid #FC8B8F;border-radius: 50%;
            font-size: .24rem;font-weight: 300;color: #FC8B8F;text-align:center;
            display:flex;align-items:center;justify-content:center;
          }
        }
      }
      .msg{
        flex:1;height: 7.6rem;margin-top:.6rem;
        .card{
          height: 1.9rem;background: #FFFFFF;width:100%;box-shadow: 0px .02rem .16rem .02rem rgba(81, 78, 107, 0.1);border-radius: .1rem;
          opacity:0;transition: all 2s;position: relative;
          div{
            height: .7rem;font-size: .28rem;font-weight: 300;color: #FC8B8F;line-height: .68rem;padding: 0 .22rem;border-bottom:1px solid #EEEEEE;
          }
          p{
            height: .28rem;font-size: .28rem;font-weight: 300;color: #666666;line-height: .28rem;padding: 0 .2rem;margin-top:.2rem;
            span{
              color:#FC8B8F;
            }
          }
          b{
            height: .24rem;font-size: .24rem;font-weight: 300;color: #666666;line-height: .24rem;display:block;padding: 0 .2rem;margin-top:.18rem;
            span{
              color:#FC8B8F;
            }
          }
        }
        .card.active{
          opacity:1;
        }
      }
    }
  }
`;